import React from 'react';
const rebrandingSignalUnlocked = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.25358 5.33301C5.25358 3.40001 6.82058 1.83301 8.75358 1.83301C10.6866 1.83301 12.2536 3.40001 12.2536 5.33301V7.33301H13.4202V13.9997H4.08691V7.33301H10.5869V5.33301C10.5869 4.32049 9.7661 3.49967 8.75358 3.49967C7.74106 3.49967 6.92025 4.32049 6.92025 5.33301V5.99967H5.25358V5.33301ZM9.75358 10.9997C9.75358 10.7035 9.62483 10.4374 9.42025 10.2543V9.33301H8.08691V10.2543C7.88233 10.4374 7.75358 10.7035 7.75358 10.9997C7.75358 11.552 8.2013 11.9997 8.75358 11.9997C9.30587 11.9997 9.75358 11.552 9.75358 10.9997Z"
            fill="#324EFC"
        />
    </svg>
);
export default rebrandingSignalUnlocked;
